import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoText from '../../atoms/InfoText';
import Helpers from '../../../lib/helpers';
import CustomizationPreview from './CustomizationPreview';
import { Customization, Product } from '../../../types/Cart';

export default function ProductPreview({
  product,
  confirmationActions,
}: {
  product: Product & { key?: string };
  confirmationActions?: React.ReactElement;
}) {
  const { t } = useTranslation();

  const currencySymbol = t('components.SAR');

  const displayPrice = product.price || 0;

  return (
    <div
      className="space-y-2"
      data-testid="store-order-details-product-preview"
    >
      {/* Variants and controllers */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-y-2 sm:flex-row sm:items-center sm:gap-x-2">
          {/* Image */}
          <img
            src={product?.imageUrl}
            alt="product image"
            className="rounded-xl border !w-[66px] !h-[66px] sm:!w-[48px] sm:!h-[48px] object-cover"
          />

          <div className="">
            {/* Product name */}
            <InfoText
              text={product.name}
              className="!text-light-text-primary !text-base dark:!text-dark-text-primary"
            />

            {/* Variants */}
            <InfoText
              text={(product.selectedAttributes || product.variations)
                ?.map((s) => `${s.name}: ${s.value}`)
                .join(' - ')}
              className="!text-light-text-primary dark:!text-dark-text-primary"
            />
          </div>
        </div>

        <div className="flex items-start justify-between py-2 gap-6 sm:py-0 sm:items-center">
          {confirmationActions}

          <div className="flex items-center justify-end gap-x-1">
            <InfoText
              text={Helpers.formatMoney(displayPrice) || '0'}
              className="!text-light-text-primary !text-lg !font-semibold dark:!text-dark-text-primary"
            />

            <InfoText
              text={currencySymbol}
              className="!text-light-text-primary text-xs dark:!text-dark-text-primary"
            />
          </div>
        </div>
      </div>

      {/* Customization */}
      {!!Object.keys(product?.customization || {})?.length && (
        <CustomizationPreview
          customs={product?.customization as Customization}
        />
      )}
    </div>
  );
}
